var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(_vm.itemValue !== null)?[(!_vm.isDate)?_c('span',{domProps:{"textContent":_vm._s(_vm.itemValue)}}):_c('span',[_vm._v(_vm._s(_vm._f("dateFilter")(_vm.itemValue)))])]:_c('span',{staticStyle:{"opacity":"0.4"},domProps:{"textContent":_vm._s(_vm.$i18n.t(_vm.nullValueKey||'dashboard.table.empty'))}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }